export default __webpack_public_path__ + "static/media/More.92b7c186.svg";